"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.plans = void 0;
exports.plans = {
    premium: {
        EUR: {
            currencySymbol: '€',
            currencyCode: 'EUR',
            cycles: [
                {
                    id: 'moises-premium-yearly',
                    providers: {
                        production: {
                            paypal: {
                                planIds: ['P-2B943434U8456794LMTABGHY'],
                            },
                            stripe: {
                                planIds: ['price_1Na1DOD4PL5s1sLXgM1WP2i5'],
                            },
                        },
                        stage: {
                            paypal: {
                                planIds: ['P-2WM66298605091504MTEAAIQ'],
                            },
                            stripe: {
                                planIds: ['price_1Na17QD4PL5s1sLXTr0ld0MJ'],
                            },
                        },
                    },
                    name: 'yearly',
                    monthlyPeriod: 12,
                    regularPrice: 49.99,
                    friendlyFormat: '4.16',
                },
                {
                    id: 'moises-premium-monthly',
                    providers: {
                        production: {
                            paypal: {
                                planIds: ['P-4GE35754VN084470UMTABHZI'],
                            },
                            stripe: {
                                planIds: ['price_1Na1BPD4PL5s1sLXHZOcG8Y4'],
                            },
                        },
                        stage: {
                            paypal: {
                                planIds: ['P-4XN05918XX342492CMTD773I'],
                            },
                            stripe: {
                                planIds: ['price_1Na19dD4PL5s1sLXpec6Eytr'],
                            },
                        },
                    },
                    name: 'monthly',
                    monthlyPeriod: 1,
                    regularPrice: 6.99,
                    friendlyFormat: '6.99',
                },
            ],
        },
        US: {
            currencySymbol: '$',
            currencyCode: 'USD',
            cycles: [
                {
                    id: 'moises-premium-yearly',
                    providers: {
                        production: {
                            paypal: {
                                planIds: ['P-2LK43252R76700501LYWMQRA'],
                            },
                            revenuecat: {
                                planIds: [
                                    'yearly',
                                    'rc_promo_premium_yearly',
                                    'yearly_trial',
                                    'yearly_trial:yearlytrial',
                                    'yearlytrial',
                                    'yearly_treatment',
                                    'yearly_treatment_prod',
                                    'yearly_treatment:yearly-treatment',
                                    'yearly_trial_prod',
                                ],
                            },
                            stripe: {
                                planIds: ['plan_GZWackS2au3o6h'],
                            },
                        },
                        stage: {
                            paypal: {
                                planIds: ['P-3YB65722F8425070BLYWOECQ'],
                            },
                            revenuecat: {
                                planIds: [
                                    'yearly',
                                    'rc_promo_premium_yearly',
                                    'yearly_trial',
                                    'yearly_dev',
                                    'yearlytrial',
                                    'yearly_trial_prod',
                                    'yearly_treatment_prod',
                                    'yearly_treatment',
                                    'yearly_treatment:yearly-treatment',
                                ],
                            },
                            stripe: {
                                planIds: ['price_1IhdJiD4PL5s1sLXHrIeMXMt'],
                            },
                        },
                    },
                    name: 'yearly',
                    monthlyPeriod: 12,
                    regularPrice: 39.99,
                    friendlyFormat: '3.33',
                },
                {
                    id: 'moises-premium-monthly',
                    providers: {
                        production: {
                            paypal: {
                                planIds: ['P-1YG409718X2440516LYWMP2Q'],
                            },
                            revenuecat: {
                                planIds: [
                                    'monthly',
                                    'monthly_trial',
                                    'monthly_trial:monthlytrial',
                                    'rc_promo_premium_monthly',
                                    'monthly_treatment',
                                    'monthly_treatment_prod',
                                    'monthly_treatment:montlhy-treatment',
                                ],
                            },
                            stripe: {
                                planIds: ['plan_GZWaWslfj5swet'],
                            },
                        },
                        stage: {
                            paypal: {
                                planIds: ['P-0HD41784BH837522DLYWPIYA'],
                            },
                            revenuecat: {
                                planIds: [
                                    'monthly',
                                    'monthly_trial',
                                    'monthly_trial:monthlytrial',
                                    'rc_promo_premium_monthly',
                                    'monthly_dev',
                                    'monthly_treatment',
                                    'monthly_treatment_prod',
                                    'monthly_treatment:montlhy-treatment',
                                ],
                            },
                            stripe: {
                                planIds: ['price_1IhdJiD4PL5s1sLXtR93WZYb'],
                            },
                        },
                    },
                    name: 'monthly',
                    monthlyPeriod: 1,
                    regularPrice: 3.99,
                    friendlyFormat: '3.99',
                },
            ],
        },
        BR: {
            currencySymbol: 'R$',
            currencyCode: 'BRL',
            legacyPricing: [
                {
                    version: 0,
                    cutDate: new Date('2023-08-11'),
                    cycles: [
                        {
                            name: 'moises-premium-yearly',
                            regularPrice: 164.9,
                        },
                        {
                            name: 'moises-premium-monthly',
                            regularPrice: 16.9,
                        },
                    ],
                },
            ],
            cycles: [
                {
                    id: 'moises-premium-yearly',
                    providers: {
                        production: {
                            stripe: {
                                planIds: ['price_1NaIYcD4PL5s1sLXU4JyupqX'],
                            },
                            paypal: {
                                planIds: ['P-8A746745DH924450GMS7NAVQ'],
                            },
                        },
                        stage: {
                            stripe: {
                                planIds: ['price_1NaIc3D4PL5s1sLXcvRj3ck0'],
                            },
                            paypal: {
                                planIds: ['P-24X568987P254735BMS7OVSI'],
                            },
                        },
                    },
                    name: 'yearly',
                    monthlyPeriod: 12,
                    regularPrice: 69.9,
                    friendlyFormat: '5,82',
                },
                {
                    id: 'moises-premium-monthly',
                    providers: {
                        production: {
                            stripe: {
                                planIds: ['price_1NaIZGD4PL5s1sLXVzgMHwSE'],
                            },
                            paypal: {
                                planIds: ['P-0C350614GG0113026MS7NB7I'],
                            },
                        },
                        stage: {
                            stripe: {
                                planIds: ['price_1NaIbSD4PL5s1sLXqOk4A9Qn'],
                            },
                            paypal: {
                                planIds: ['P-9VE39847WR897282AMS7OVBA'],
                            },
                        },
                    },
                    name: 'monthly',
                    monthlyPeriod: 1,
                    regularPrice: 9.9,
                    friendlyFormat: '9,90',
                },
            ],
        },
    },
    pro: {
        US: {
            currencySymbol: '$',
            currencyCode: 'USD',
            cycles: [
                {
                    id: 'moises-pro-yearly',
                    providers: {
                        production: {
                            stripe: {
                                planIds: ['price_1NqKyGD4PL5s1sLXgORkCn8F'],
                                paymentLink: [
                                    {
                                        // free users
                                        planId: 'price_1NqKyGD4PL5s1sLXgORkCn8F',
                                        link: 'https://buy.stripe.com/00gdR37980Ke7NS3cq',
                                        paymentId: 'plink_1NqL80D4PL5s1sLXLt0jLo5D',
                                        hasTrial: true,
                                        promoCode: 'pro50off',
                                    },
                                    {
                                        // premium or trial upgrading users
                                        planId: 'price_1NqKyGD4PL5s1sLXgORkCn8F',
                                        link: 'https://buy.stripe.com/5kAdR3dxwgJc8RW4gA',
                                        paymentId: 'plink_1NqhRyD4PL5s1sLXqxDJp2Xm',
                                        hasTrial: false,
                                        couponId: 'GG0Y1vyi',
                                        promoCodeId: 'promo_1NqjIYD4PL5s1sLXlpBL4l5g',
                                        promoCode: 'pro50off',
                                    },
                                ],
                            },
                        },
                        stage: {
                            stripe: {
                                planIds: ['price_1NqHOiD4PL5s1sLXHnwdxPjP'],
                                paymentLink: [
                                    {
                                        // free users
                                        planId: 'price_1NqHOiD4PL5s1sLXHnwdxPjP',
                                        link: 'https://buy.stripe.com/test_eVa29RcwP7xr5bybJs',
                                        paymentId: 'plink_1NqHbqD4PL5s1sLXE1xNFlUY',
                                        hasTrial: true,
                                        promoCode: 'pro50off',
                                    },
                                    {
                                        // premium or trial upgrading users
                                        planId: 'price_1NqHOiD4PL5s1sLXHnwdxPjP',
                                        link: 'https://buy.stripe.com/test_cN24hZ1Sb4lf5by8xi',
                                        paymentId: 'plink_1NqNzDD4PL5s1sLXlaoXgDB7',
                                        hasTrial: false,
                                        couponId: 'kdXdNFqR',
                                        promoCodeId: 'promo_1NqjZpD4PL5s1sLXPUvrsRQw',
                                        promoCode: 'pro50off',
                                    },
                                ],
                            },
                        },
                    },
                    name: 'yearly',
                    monthlyPeriod: 12,
                    regularPrice: 299.99,
                    friendlyFormat: '24.99',
                },
                {
                    id: 'moises-pro-monthly',
                    providers: {
                        production: {
                            stripe: {
                                planIds: ['price_1NqKwsD4PL5s1sLXpTMCkyKR'],
                                paymentLink: [
                                    {
                                        // free users
                                        planId: 'price_1NqKwsD4PL5s1sLXpTMCkyKR',
                                        link: 'https://buy.stripe.com/eVa6oBdxwfF89W05kz',
                                        paymentId: 'plink_1NqLD1D4PL5s1sLXksZWyCCD',
                                        hasTrial: true,
                                        promoCode: 'pro50off',
                                    },
                                    {
                                        // premium or trial upgrading users
                                        planId: 'price_1NqKwsD4PL5s1sLXpTMCkyKR',
                                        link: 'https://buy.stripe.com/9AQ3cpeBA1Oi7NS28t',
                                        paymentId: 'plink_1NqhTwD4PL5s1sLXGWqktmGb',
                                        hasTrial: false,
                                        couponId: 'GG0Y1vyi',
                                        promoCodeId: 'promo_1NqjIYD4PL5s1sLXlpBL4l5g',
                                        promoCode: 'pro50off',
                                    },
                                ],
                            },
                        },
                        stage: {
                            stripe: {
                                planIds: ['price_1NpepnD4PL5s1sLXOLJox0Uz'],
                                paymentLink: [
                                    {
                                        // free users
                                        planId: 'price_1NpepnD4PL5s1sLXOLJox0Uz',
                                        link: 'https://buy.stripe.com/test_8wMbKrfJ19FzcE014P',
                                        paymentId: 'plink_1NqHq6D4PL5s1sLXgiLNDLN5',
                                        hasTrial: true,
                                        promoCode: 'pro50off',
                                    },
                                    {
                                        // premium or trial upgrading users
                                        planId: 'price_1NpepnD4PL5s1sLXOLJox0Uz',
                                        link: 'https://buy.stripe.com/test_eVa3dVdAT2d76fCdRD',
                                        paymentId: 'plink_1NqO4lD4PL5s1sLX5iRzUUgS',
                                        hasTrial: false,
                                        couponId: 'kdXdNFqR',
                                        promoCodeId: 'promo_1NqjZpD4PL5s1sLXPUvrsRQw',
                                        promoCode: 'pro50off',
                                    },
                                ],
                            },
                        },
                    },
                    name: 'monthly',
                    monthlyPeriod: 1,
                    regularPrice: 29.99,
                    friendlyFormat: '29.99',
                },
            ],
        },
        EUR: {
            currencySymbol: '€',
            currencyCode: 'EUR',
            cycles: [
                {
                    id: 'moises-pro-yearly',
                    providers: {
                        production: {
                            stripe: {
                                planIds: ['price_1NqKzzD4PL5s1sLXncCMHcDN'],
                                paymentLink: [
                                    {
                                        // free users
                                        planId: 'price_1NqKzzD4PL5s1sLXncCMHcDN',
                                        link: 'https://buy.stripe.com/6oE7sFgJI1Oi8RWeVa',
                                        paymentId: 'plink_1NqLyTD4PL5s1sLX0jvIb1rr',
                                        hasTrial: true,
                                        promoCode: 'pro50off',
                                    },
                                    {
                                        // premium or trial upgrading users
                                        planId: 'price_1NqKzzD4PL5s1sLXncCMHcDN',
                                        link: 'https://buy.stripe.com/dR68wJdxwdx09W09AW',
                                        paymentId: 'plink_1NqhpMD4PL5s1sLXN0KJvJxN',
                                        hasTrial: false,
                                        couponId: 'GG0Y1vyi',
                                        promoCodeId: 'promo_1NqjIYD4PL5s1sLXlpBL4l5g',
                                        promoCode: 'pro50off',
                                    },
                                ],
                            },
                        },
                        stage: {
                            stripe: {
                                planIds: ['price_1Nn87eD4PL5s1sLXO0j11wYg'],
                                paymentLink: [
                                    {
                                        // free users
                                        planId: 'price_1Nn87eD4PL5s1sLXO0j11wYg',
                                        link: 'https://buy.stripe.com/test_00geWD1Sb1937jG6p2',
                                        paymentId: 'plink_1NnMqbD4PL5s1sLXrvT9Dzbk',
                                        hasTrial: true,
                                        promoCode: 'pro50off',
                                    },
                                    {
                                        // premium or trial upgrading users
                                        planId: 'price_1Nn87eD4PL5s1sLXO0j11wYg',
                                        link: 'https://buy.stripe.com/test_00g6q740j8BvgUg28W',
                                        paymentId: 'plink_1NqP29D4PL5s1sLXb1BfIdrP',
                                        hasTrial: false,
                                        couponId: 'kdXdNFqR',
                                        promoCodeId: 'promo_1NqjZpD4PL5s1sLXPUvrsRQw',
                                        promoCode: 'pro50off',
                                    },
                                ],
                            },
                        },
                    },
                    name: 'yearly',
                    monthlyPeriod: 12,
                    regularPrice: 349.99,
                    friendlyFormat: '29.16',
                },
                {
                    id: 'moises-pro-monthly',
                    providers: {
                        production: {
                            stripe: {
                                planIds: ['price_1NqL0vD4PL5s1sLXNk23EJr9'],
                                paymentLink: [
                                    {
                                        // free users
                                        planId: 'price_1NqL0vD4PL5s1sLXNk23EJr9',
                                        link: 'https://buy.stripe.com/6oE8wJ79864yfgk5kB',
                                        paymentId: 'plink_1NqM0BD4PL5s1sLXfLr66Y3S',
                                        hasTrial: true,
                                        promoCode: 'pro50off',
                                    },
                                    {
                                        // premium or trial upgrading users
                                        planId: 'price_1NqL0vD4PL5s1sLXNk23EJr9',
                                        link: 'https://buy.stripe.com/eVaeV79hgfF8fgk00n',
                                        paymentId: 'plink_1NqhuqD4PL5s1sLX5bERWnuC',
                                        hasTrial: false,
                                        couponId: 'GG0Y1vyi',
                                        promoCodeId: 'promo_1NqjIYD4PL5s1sLXlpBL4l5g',
                                        promoCode: 'pro50off',
                                    },
                                ],
                            },
                        },
                        stage: {
                            stripe: {
                                planIds: ['price_1Nn874D4PL5s1sLXAqbibBTA'],
                                paymentLink: [
                                    {
                                        // free users
                                        planId: 'price_1Nn874D4PL5s1sLXAqbibBTA',
                                        link: 'https://buy.stripe.com/test_4gw6q7gN56tnfQc6p3',
                                        paymentId: 'plink_1NnMrTD4PL5s1sLX6iz1XUWY',
                                        hasTrial: true,
                                        promoCode: 'pro50off',
                                    },
                                    {
                                        // premium or trial upgrading users
                                        planId: 'price_1Nn874D4PL5s1sLXAqbibBTA',
                                        link: 'https://buy.stripe.com/test_cN25m3eEX2d733q28X',
                                        paymentId: 'plink_1Nqe5hD4PL5s1sLX8RrWulsU',
                                        hasTrial: false,
                                        couponId: 'kdXdNFqR',
                                        promoCodeId: 'promo_1NqjZpD4PL5s1sLXPUvrsRQw',
                                        promoCode: 'pro50off',
                                    },
                                ],
                            },
                        },
                    },
                    name: 'monthly',
                    monthlyPeriod: 1,
                    regularPrice: 34.99,
                    friendlyFormat: '34.99',
                },
            ],
        },
        BR: {
            currencySymbol: 'R$',
            currencyCode: 'BRL',
            cycles: [
                {
                    id: 'moises-pro-yearly',
                    providers: {
                        production: {
                            stripe: {
                                planIds: ['price_1NqL2pD4PL5s1sLXeXrMpJFr'],
                                paymentLink: [
                                    {
                                        // free users
                                        planId: 'price_1NqL2pD4PL5s1sLXeXrMpJFr',
                                        link: 'https://buy.stripe.com/00g5kx3WW1Oi3xC3cv',
                                        paymentId: 'plink_1NqM7sD4PL5s1sLXz55etSMa',
                                        hasTrial: true,
                                        promoCode: 'pro50off',
                                    },
                                    {
                                        // premium or trial upgrading users
                                        planId: 'price_1NqL2pD4PL5s1sLXeXrMpJFr',
                                        link: 'https://buy.stripe.com/fZebIV798eB45FK7sQ',
                                        paymentId: 'plink_1NqhwXD4PL5s1sLXbfJKLVJi',
                                        hasTrial: false,
                                        couponId: 'GG0Y1vyi',
                                        promoCodeId: 'promo_1NqjIYD4PL5s1sLXlpBL4l5g',
                                        promoCode: 'pro50off',
                                    },
                                ],
                            },
                        },
                        stage: {
                            stripe: {
                                planIds: ['price_1Nn85QD4PL5s1sLXfMbo1GKe'],
                                paymentLink: [
                                    {
                                        // free users
                                        planId: 'price_1Nn85QD4PL5s1sLXfMbo1GKe',
                                        link: 'https://buy.stripe.com/test_5kA15NaoH9FzcE0fZF',
                                        paymentId: 'plink_1NnMtgD4PL5s1sLXWhrOjKfo',
                                        hasTrial: true,
                                        promoCode: 'pro50off',
                                    },
                                    {
                                        // premium or trial upgrading users
                                        planId: 'price_1Nn85QD4PL5s1sLXfMbo1GKe',
                                        link: 'https://buy.stripe.com/test_6oEeWD40jdVPavS14V',
                                        paymentId: 'plink_1NqeOPD4PL5s1sLXLWltVIMR',
                                        hasTrial: false,
                                        couponId: 'kdXdNFqR',
                                        promoCodeId: 'promo_1NqjZpD4PL5s1sLXPUvrsRQw',
                                        promoCode: 'pro50off',
                                    },
                                ],
                            },
                        },
                    },
                    name: 'yearly',
                    monthlyPeriod: 12,
                    regularPrice: 499.99,
                    friendlyFormat: '41.66',
                },
                {
                    id: 'moises-pro-monthly',
                    providers: {
                        production: {
                            stripe: {
                                planIds: ['price_1NqL2CD4PL5s1sLXASlb65Nt'],
                                paymentLink: [
                                    {
                                        // free users
                                        planId: 'price_1NqL2CD4PL5s1sLXASlb65Nt',
                                        link: 'https://buy.stripe.com/bIY7sF2SS1Oi2tyaEW',
                                        paymentId: 'plink_1NqM5QD4PL5s1sLXE3DZIgZA',
                                        hasTrial: true,
                                        promoCode: 'pro50off',
                                    },
                                    {
                                        // premium or trial upgrading users
                                        planId: 'price_1NqL2CD4PL5s1sLXASlb65Nt',
                                        link: 'https://buy.stripe.com/7sI28l7981Oib0414t',
                                        paymentId: 'plink_1NqhyeD4PL5s1sLXlTLj5Oln',
                                        hasTrial: false,
                                        couponId: 'GG0Y1vyi',
                                        promoCodeId: 'promo_1NqjIYD4PL5s1sLXlpBL4l5g',
                                        promoCode: 'pro50off',
                                    },
                                ],
                            },
                        },
                        stage: {
                            stripe: {
                                planIds: ['price_1Nn867D4PL5s1sLXjVNr5Fzc'],
                                paymentLink: [
                                    {
                                        // free users
                                        planId: 'price_1Nn867D4PL5s1sLXjVNr5Fzc',
                                        link: 'https://buy.stripe.com/test_8wMeWD68r2d7cE07t8',
                                        paymentId: 'plink_1NnMsiD4PL5s1sLXsIOqckjj',
                                        hasTrial: true,
                                        promoCode: 'pro50off',
                                    },
                                    {
                                        // premium or trial upgrading users
                                        planId: 'price_1Nn867D4PL5s1sLXjVNr5Fzc',
                                        link: 'https://buy.stripe.com/test_3cs6q71Sb5pj7jG7ti',
                                        paymentId: 'plink_1Nqe7eD4PL5s1sLXHlTEqmnk',
                                        hasTrial: false,
                                        couponId: 'kdXdNFqR',
                                        promoCodeId: 'promo_1NqjZpD4PL5s1sLXPUvrsRQw',
                                        promoCode: 'pro50off',
                                    },
                                ],
                            },
                        },
                    },
                    name: 'monthly',
                    monthlyPeriod: 1,
                    regularPrice: 49.99,
                    friendlyFormat: '49.99',
                },
            ],
        },
    },
};
